import Marquee from '../Marquee';
import { ReactNode } from 'react';
import { makeClassName } from '@siteless/util';
import { zIndex } from '../../config/constants';

let bannerShadow =
  '0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12)';

const Banner = ({
  body = null,
  subtitle = null,
  label = null,
  className,
  onClick,
  footer = null,
}: {
  body?: ReactNode;
  subtitle?: ReactNode;
  label?: ReactNode;
  className?: string;
  onClick?: () => void;
  footer?: ReactNode;
}) => {
  return (
    <div
      className={makeClassName(
        // Sticky only so iOS sees a bar along the top: in a Home Screen web
        // app it then gives the status bar the banner's white, where otherwise
        // it blurs over the banner. Nothing it sits in scrolls, so it stays put.
        'bg-neutral-0 sticky top-0 mx-3 rounded-b-xl border-4 border-t-0 border-neutral-200 pt-3 pb-2 text-purple-900 sm:mx-auto sm:w-[500px]',
        onClick && 'cursor-pointer',
        className,
      )}
      style={{
        boxShadow: bannerShadow,
        zIndex: zIndex.banner,
      }}
      onClick={onClick}
    >
      <div className="mb-1.5 flex items-end px-3 text-sm font-medium uppercase text-rose-default">
        {label}
      </div>
      <div className="mb-2 truncate text-lg">
        <Marquee speed={30}>
          <div className="px-5">{body}</div>
        </Marquee>
      </div>
      {subtitle && (
        <div
          className={makeClassName(
            'overflow-hidden flex justify-center gap-2 text-ellipsis whitespace-nowrap border-t-2 border-dashed border-neutral-200 px-10 py-1.5 text-center text-[0.8rem] font-medium text-purple-700 mt-1',
            footer ? 'mb-0' : '-mb-2',
          )}
        >
          {subtitle}
        </div>
      )}
      {footer && (
        <div className="-mx-1 -mb-2 mt-1 flex items-center justify-center gap-1.5 rounded-b-lg bg-neutral-200 px-3 pt-1 pb-0.5 text-[0.75rem] font-medium text-purple-800">
          {footer}
        </div>
      )}
    </div>
  );
};

export default Banner;
